import { PermissionResource } from '@tests/types';
import { Dispatch, SetStateAction } from 'react';

import { EntityFilter } from '@/atoms';
import { employeesFilterSelector } from '@/selectors';
import { useGetFilterCreatedByEmployeesQuery } from '@/services';

type FiltersItem = {
  label: string;
  value: number;
};

type FiltersProps = {
  classname?: string;
  onChange?: Dispatch<SetStateAction<FiltersItem[]>>;
  value?: FiltersItem[];
};

export const EmployeesFilter: React.FC<FiltersProps> = ({ classname, onChange, value }) => (
  <EntityFilter
    useEntityListQuery={useGetFilterCreatedByEmployeesQuery}
    entitySelector={employeesFilterSelector}
    permissionResource={PermissionResource.Test} // NOTE: Разрешение для фильтров теста Test:Read
    checkedItems={value}
    setCheckedItems={onChange}
    classname={classname}
  />
);
